var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoRegulatoryReports = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18182 0V3.27273C8.18182 5.0802 9.64707 6.54545 11.4545 6.54545H14.7273V14.7273C14.7273 16.5347 14.8075 18 13 18H3.27273C1.46525 18 0 18.3075 0 16.5V3.27273C0 1.46525 0.192523 0 2 0H8.18182ZM9.81818 0.47928V3.27273C9.81818 4.17647 10.5508 4.90909 11.4545 4.90909H14.248L9.81818 0.47928ZM7.36364 9H4.09091C3.63904 9 3.27273 9.36631 3.27273 9.81818V13.9091V14.7273V15.5455H4.09091H7.36364V9ZM8.18182 15.5455H10.6364H11.4545V14.7273V13.9091V11.4545C11.4545 11.0027 11.0882 10.6364 10.6364 10.6364H8.18182V15.5455ZM3.27273 4.90909H6.54545V3.27273H3.27273V4.90909ZM7.36364 7.36364H3.27273V5.72727H7.36364V7.36364Z",
    fill: "#8D939C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoRegulatoryReports);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_regulatory_reports.abbb6feb01e1def0619d29eb1b38d220.svg";